import { Swiper, SwiperSlide } from 'swiper/react';
import {Navigation,Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import parse from "html-react-parser";
import { STORAGEURL } from '..';

const FeedbackSwiper = ({items,className=''}) => {
    if (items) return (
        <div className={'pt-7 mobil:px-4 '+className}>
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={items.length>1?window.innerWidth>600?50:25:0}
              slidesPerView={(window.innerWidth>600&&items.length>1)?2:1}
              centeredSlides={true}
              navigation={true}
              pagination={true}
              className="feedbackSwiper !pb-7"
            >
              {items.map((item,i)=><SwiperSlide key={i} 
                  className={'bg-purplee-200 border-[#DCD3F6] border-4 p-7 rounded-xl !flex tablet:flex-col items-start gap-4 max-w-3xl '+(items.length===1&&"!m-auto")}
                >
                <img src={STORAGEURL+item.img} />
                <div className='text-left'>
                  <strong className='text-purplee-100 text-4xl block w-full leading-none'>“</strong>
                  <div className="parsedDiv !pt-0">{parse(item.desc||'')}</div>
                  <b>{item.item_name}</b>
                </div>
              </SwiperSlide>)}
            </Swiper>
        </div>
    )
}

export default FeedbackSwiper;